import {
  Paper,
  Grid2,
  Card,
  Typography,
  CardActionArea,
  Box,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import classes from "./css/products-list.module.css";
import * as services from "./../../services/saleng";
import toast, { Toaster } from "react-hot-toast";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { useCart } from "./../../CartContext";
import { useLocation, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ImageIcon from "@mui/icons-material/Image";
import CategoryIcon from "@mui/icons-material/Category";
import WeightDialog from "../../components/CarScaleDialog";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import CancelIcon from "@mui/icons-material/Cancel";
import PDFDialog from "./components/pdf_dialog";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import TuneIcon from "@mui/icons-material/Tune";
import {
  generateDeliveryNotePdfBlob,
  generateDeliveryNotePdf,
} from "./components/generateDeliveryNotePdf";
import {
  generateDeliveryNoteSalePdfBlob,
  generateDeliveryNoteSalePdf,
} from "./components/generateDeliveryNoteSentPdf";
import {
  generateInvoicePdf,
  generateInvoicePdfBlob,
} from "./components/generateInvoicePdf";
import { formatNumber } from "./../../utils/formatNumber";
import ImageModal from "../../components/ImageModal";
import CarSelectDialog from "../../components/CarSelectDialog";
import StockTypeDialog from "./components/StockTypeDialog";
import PackageSelectDialog from "./components/PackageSelectDialog";
import Avatar from "@mui/material/Avatar";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import Badge from "@mui/material/Badge";
import DescriptionIcon from "@mui/icons-material/Description";
import { green, yellow } from "@mui/material/colors";
import ChecklistIcon from "@mui/icons-material/Checklist";
import SalesProductFormDialog from "../../components/SaleProductFormDialog ";
import SaleCustomerPickerDialog from "../../components/SaleCustomerPickerDialog";
import SOSelectionDialog from "./components/SOSelectionDialog";
import SaleInsuranceExtraPriceModal from "./components/SaleInsuranceExtraPriceModal";
import ItemTableModal from "../../components/ItemTableModal";
import { getContrastColor } from "../../utils/fontColor";
import PaymentMethodDialog from "./components/pdf_dialog";
import { hasPermission } from "../../auth/RequirePermission3";
import Delivery from "./modal/modal_delivery";
import SaleDestinationConfirmDialog from "../../components/SaleDestinationConfirmDialog";

import { allocateSaleLocks } from "../../utils/saleLockPricing";

const isSpacerCard = (card) => Boolean(card?.type === "spacer");

const createSpacerCard = (position) => ({
  type: "spacer",
  spacerId: `layout-spacer-${position}`,
});

const buildCardsWithSpacers = (layout, productMap) => {
  if (!Array.isArray(layout) || layout.length === 0) {
    return Object.values(productMap);
  }

  const sortedLayout = [...layout].sort(
    (a, b) => Number(a.position ?? 0) - Number(b.position ?? 0)
  );
  const cardsByPosition = new Map(
    sortedLayout.map((item) => [Number(item.position ?? 0), productMap[item.productId]])
  );
  const maxPosition = sortedLayout.reduce(
    (max, item) => Math.max(max, Number(item.position ?? 0)),
    -1
  );

  return Array.from({ length: maxPosition + 1 }, (_, index) => {
    const card = cardsByPosition.get(index);
    return card ?? createSpacerCard(index);
  });
};

const Page = ({ tabId, tabData }) => {
  const navigate = useNavigate();
  const { cart, dispatch } = useCart();
  const [cards, setCards] = useState([]);
  const [data, setData] = useState([]);
  const [waitingSaleNetByProductId, setWaitingSaleNetByProductId] = useState({});
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subFilter, setSubFilter] = useState("ทั้งหมด");
  const [filter, setFilter] = useState("ทุกประเภท");
  const [selectedValue, setSelectedValue] = useState(0);
  const [transaction, setTransaction] = useState(null);
  const [totalNetWeight, setTotalNetWeight] = useState();
  const [totalNetPrice, setTotalNetPrice] = useState();
  const [note, setNote] = useState();
  const handleNoteChange = (e) => setNote(e.target.value);
  const [isWeighed, setIsWeighed] = useState(true);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedImage, setSelectedImage] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [openImg, setOpenImg] = useState(false);
  const [type, setType] = useState("retail");

  const query = useQuery();
  const transactionId = query.get("id");

  const [soItems, setSoItems] = useState([]);
  const [soSelect, setSoSelect] = useState([]);
  const [lockItems, setLockItems] = useState([]);
  const [lockSelect, setLockSelect] = useState([]);
  const [locksLoading, setLocksLoading] = useState(false);
  const [locksError, setLocksError] = useState("");
  const pricingSaveRef = useRef(Promise.resolve());
  const pricingSaveErrorRef = useRef(null);
  const hydratedTransactionRef = useRef(null);
  const insuranceEnabled = transaction?.branch?.usePriceInsurance === true;

  const [transactionBreakdown, setTransactionBreakdown] = useState([]);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [imageDetail, setImageDetail] = useState([]);

  // dialog
  const [openSOSelectionDialog, setOpenSOSelectionDialog] = useState(false);
  const [openShippingDialog, setOpenShippingDialog] = useState(false);
  const [openCarDialog, setOpenCarDialog] = useState(false);
  const [openStockTypeDialog, setOpenStockTypeDialog] = useState(false);
  const [openPackageSelectDialog, setOpenPackageSelectDialog] = useState(false);
  const [openCustomerPickerDialog, setOpenCustomerPickerDialog] =
    useState(false);
  const [openProductDialog, setOpenProductDialog] = useState(false);
  const [openPDF, setOpenPDF] = useState(false);
  const [openItemDialog, setOpenItemDialog] = useState(false);
  const [openSaleExtraPriceDialog, setOpenSaleExtraPriceDialog] = useState(false);
  const [selectedSaleExtraItem, setSelectedSaleExtraItem] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [openPrintDialog, setOpenPrintDialog] = useState(false);
  const [openDestinationDialog, setOpenDestinationDialog] = useState(false);
  const N = (v) => Number(v ?? 0) || 0;
  const items = Array.isArray(transaction?.items) ? transaction?.items : [];

  const totalWeight = items.reduce((s, it) => s + N(it.weight), 0);
  const totalDeductWeight = items.reduce((s, it) => s + N(it.deductWeight), 0);
  const totalImpurityWeight = items.reduce((s, it) => s + N(it.impurityWeight), 0);
  const canEditSaleItems = transaction?.status === "waiting";
  const showConfirmedSaleView = ["sent", "confirm", "payed"].includes(
    transaction?.status
  );
  const stockByProductId = useMemo(
    () =>
      cards.reduce((stockMap, card) => {
        if (card?.productId != null) {
          stockMap[card.productId] = N(card.stock);
        }
        return stockMap;
      }, {}),
    [cards]
  );
  // useEffect(() => {
  //   let revoke;
  //   const run = async () => {
  //     if (!transaction) return;
  //     const blob = await generateInvoicePdfBlob(transaction);
  //     const url = URL.createObjectURL(blob);
  //     setPdfUrl(url);
  //     revoke = () => URL.revokeObjectURL(url);
  //   };
  //   run();
  //   return () => {
  //     if (revoke) revoke();
  //   };
  // }, [transaction]);

  const setPdfFromBlob = (blob) => {
    if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    const url = URL.createObjectURL(blob);
    setPdfUrl(`${url}#zoom=page-width`); // ให้พอดีกว้าง
  };

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const handleConfirm = async (data) => {
    // data.imageUrl is backward compatibility for final confirm image
    // data.snapshots is the new array of multiple captures (keypad OK + final confirm)
    const snapshots = data.snapshots || [];

    // Map all images into the required format for transaction images
    const images = (snapshots.length > 0 ? snapshots : (data.imageUrl ? [{ url: data.imageUrl, label: "confirm" }] : []))
      .filter(s => s.url)
      .map(s => ({
        imageUrl: s.url,
        type: "img",
        meta: {
          at: s.at || new Date().toISOString(),
          label: s.label || "img"
        }
      }));

    let payload = {
      carHeavyWeight: parseFloat(data.heavy || 0),
      carLightWeight: parseFloat(data.light || 0),
      ...(images.length > 0 && { images }),
    };

    await services.updateSaleTransaction(payload, transactionId);
    fetchData();
    setOpenCarDialog(false);
  };

  const fetchData = useCallback(async () => {
    try {
      const response = await services.getProductsBranch(true);
      const products = response.data.data;

      await pricingSaveRef.current.catch(() => {});
      const transaction_res = await services.getSaleTransaction(transactionId);
      const trx = transaction_res.data.data;
      const savedLocks = new Map();
      (trx?.items || []).forEach((item) => (item.lockPricingAllocations || []).forEach((allocation) => {
        savedLocks.set(allocation.lockPricingId, {
          ...allocation.lockPricing, specialPrice: allocation.pricePerUnit,
        });
      }));
      let availableLocks = [];
      if (trx?.branch?.usePriceInsurance) {
        const response = await services.getSaleLockPricingOptions(trx.branchId, trx.shopId, transactionId);
        availableLocks = response.data || [];
      }
      setLockItems(availableLocks);
      const availableById = new Map(availableLocks.map((lock) => [lock.id, lock]));
      const sameTransaction = hydratedTransactionRef.current === transactionId;
      const selectedSOByOrder = new Map();
      (trx?.items || []).forEach((transactionItem) => {
        (transactionItem?.saleOrderItems || []).forEach((saleOrderItem) => {
          const saleOrder = saleOrderItem?.saleOrder;
          if (!saleOrder?.id) return;

          if (!selectedSOByOrder.has(saleOrder.id)) {
            selectedSOByOrder.set(saleOrder.id, {
              ...saleOrder,
              items: [],
            });
          }

          const selectedOrder = selectedSOByOrder.get(saleOrder.id);
          if (!selectedOrder.items.some((item) => item.id === saleOrderItem.id)) {
            const item = { ...saleOrderItem };
            delete item.saleOrder;
            selectedOrder.items.push(item);
          }
        });
      });
      const waitingSalesRes = await services.getSaleTransactions({ status: "waiting" });
      const waitingSales = waitingSalesRes?.data?.data ?? [];
      const layoutRes = await services.getUserLayout(1);
      const layout = layoutRes?.data ?? [];

      const waitingTotals = waitingSales.reduce((totals, saleTransaction) => {
        (saleTransaction?.items || []).forEach((item) => {
          if (item?.productId == null) return;
          const productId = item.productId;
          totals[productId] =
            (totals[productId] || 0) + Math.max(0, N(item.netWeight));
        });
        return totals;
      }, {});
      setWaitingSaleNetByProductId(waitingTotals);

      const productMap = {};
      products.forEach((item) => {
        productMap[item.id] = {
          ...item,
          productId: item.id,
          categoryName: item.category?.name ?? "ไม่ระบุ",
          color: item.subCategory?.color ?? "royalblue",
          finalPrice: 0,
        };
      });

      const box1Layout = layout.filter((l) => l.box === "box1");
      const sortedCards = buildCardsWithSpacers(box1Layout, productMap);

      setLockSelect((previous) => savedLocks.size
        ? [...savedLocks.values()].map((lock) => availableById.get(lock.id) ?? lock)
        : sameTransaction ? previous : []);
      hydratedTransactionRef.current = transactionId;
      setSoSelect(Array.from(selectedSOByOrder.values()));
      setTransaction(trx);
      setIsWeighed(trx.isWeighed);
      setNote(trx.note || "");

      const totalNetWeight = trx.items.reduce(
        (sum, item) => sum + (item.netWeight || 0),
        0
      );
      const totalNetPrice = trx.items.reduce(
        (sum, item) => sum + (item.netPrice || 0),
        0
      );
      setTotalNetWeight(totalNetWeight);
      setTotalNetPrice(totalNetPrice);
      const res = await services.getInventory();
      const rawData = res.data.data;
      // แปลงข้อมูลจาก rawData
      const transformed = rawData.map((item, index) => {
        return {
          id: index + 1,
          productId: item.productId,
          title: item.product?.title || "",
          basePrice: item.product?.price || 0,
          price: item.averageCost || 0,
          visible: item.quantity > 0,
          branchId: item.branchId,
          categoryId: item.product?.categoryId || null,
          subCategoryId: item.product?.subCategoryId || null,
          category: {
            id: item.product?.category?.id,
            name: item.product?.category?.name,
          },
          subCategory: {
            id: item.product?.subCategory?.id,
            name: item.product?.subCategory?.name,
          },
          image: item.product?.image || null,
          stock: item.quantity || 0,
        };
      });
      // setData(transformed);
      const categoryMap = products
        .map((p) => p?.category)
        .filter(Boolean)
        .reduce((acc, cur) => {
          if (!acc.some((c) => c.id === cur.id)) {
            acc.push(cur);
          }
          return acc;
        }, []);
      const sortedCategories = categoryMap.sort(
        (a, b) => (a.order ?? 0) - (b.order ?? 0)
      );
      const categories = ["ทุกประเภท", ...sortedCategories.map((c) => c.name)];
      setCategories?.(categories);
      if (categories.length > 0 && filter === "ทุกประเภท") {
        setFilter?.("ทุกประเภท");
      }

      const stockMap = new Map(
        (transformed || []).map((s) => [s.productId, s.stock])
      );

      const mergedProducts = (sortedCards || []).map((p) => {
        const stock = stockMap.get(p.productId) ?? 0;
        return { ...p, stock };
      });
      setCards?.(mergedProducts);

      setData?.(mergedProducts);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [transactionId]);

  useEffect(() => {
    if (filter === "ทุกประเภท") {
      setSubCategories([]);
    } else {
      const subs = data
        .filter((c) => c?.category?.name === filter && c?.subCategory?.name)
        .map((c) => c.subCategory.name);
      setSubCategories([...new Set(subs)]);
    }
  }, [data, filter]);

  // โหลด SO
  useEffect(() => {
    if (!transaction?.customerId) {
      setSoItems([]);
      return;
    }
    const fetchPOs = async () => {
      try {
        const res = await services.getSaleOrders({
          customerId: transaction?.customerId,
        });
        const saleOrders = res.data.data || [];
        setSoItems(
          saleOrders.filter(
            (saleOrder) =>
              String(saleOrder?.status || "").toLowerCase() !== "close",
          ),
        );
      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการดึง PO:", error);
      }
    };

    fetchPOs();
  }, [fetchData, transaction?.customerId, transactionId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (!openSOSelectionDialog || !insuranceEnabled) return;
    let active = true;
    setLocksLoading(true);
    setLocksError("");
    services.getSaleLockPricingOptions(transaction.branchId, transaction.shopId, transactionId)
      .then((response) => { if (active) setLockItems(response.data || []); })
      .catch(() => { if (active) setLocksError("โหลดรายการประกันราคาไม่สำเร็จ กรุณาปิดแล้วเปิดใหม่"); })
      .finally(() => { if (active) setLocksLoading(false); });
    return () => { active = false; };
  }, [openSOSelectionDialog, insuranceEnabled, transaction?.branchId, transaction?.shopId, transactionId]);

  // useEffect สำหรับคำนวณ breakdown และอัปเดต transaction
  useEffect(() => {
    if (!transaction?.items) return;

    if (hydratedTransactionRef.current !== transactionId) return;
    if (transaction.status === "waiting" && lockSelect.some((lock) => !Number.isFinite(lock.saleRemainingWeight))) {
      const error = new Error("รายการประกันราคาที่เคยเลือกไม่พร้อมใช้งาน กรุณาเลือกราคาใหม่");
      pricingSaveErrorRef.current = error;
      toast.error(error.message);
      return;
    }

    const fetchDataAndCalculate = async () => {
      const breakdownList = [];
      const usedPOMap = new Map();
      const usedLockMap = new Map();

      transaction.items.forEach((item, index) => {
        // หลังส่งตั๋วแล้ว soUsedWeight คือ "น้ำหนักที่ใช้ไปจริง" ของตั๋ว
        // ไม่ใช่น้ำหนักคงเหลือของ SO ที่ยังเลือกใช้ได้อยู่
        const isCommittedSale = ["sent", "confirm", "payed"].includes(
          String(transaction.status || "").toLowerCase(),
        );
        const selectSOItems = (soSelect ?? []).flatMap(
          (so) => so.items ?? [so]
        );

        const itemsToUse =
          selectSOItems.length > 0 ? selectSOItems : selectSOItems;

        const soItemsMap = new Map();
        itemsToUse.forEach((p) => soItemsMap.set(p.id, p));

        const preferIds = new Set(item.soItemIds || []);
        const matchingSOItems = Array.from(soItemsMap.values())
          .filter((soItem) => soItem.productId === item.productId)
          .sort((a, b) => {
            const aPrefer = preferIds.has(a.id) ? 1 : 0;
            const bPrefer = preferIds.has(b.id) ? 1 : 0;
            if (aPrefer !== bPrefer) return bPrefer - aPrefer;
            return new Date(a.createdAt || "") - new Date(b.createdAt || "");
          });

        const impurity =
          (item.impurities || []).reduce((s, i) => s + N(i.weight), 0) +
          (item.deductedItems || []).reduce((s, d) => s + N(d.weight2), 0);

        let remainingWeight = Math.max(
          0,
          N(item.weight) - N(item.deductWeight) - impurity
        );
        const breakdown = [];
        let committedSOWeightRemaining = isCommittedSale
          ? Math.min(remainingWeight, Math.max(0, N(item.soUsedWeight)))
          : null;

        const insurance = allocateSaleLocks(item, lockSelect, remainingWeight, usedLockMap, isCommittedSale);
        insurance.allocations.forEach((allocation) => breakdown.push({
          index, productId: item.productId, productName: item.productName,
          pricePerUnit: allocation.pricePerUnit, PricePerUnit: allocation.pricePerUnit,
          totalPrice: allocation.weight * allocation.pricePerUnit,
          usedWeight: allocation.weight, priceSource: "insurance", lockInfo: allocation.lockPricing,
        }));
        remainingWeight = insurance.remaining;

        // ใช้ PO ถ้ายังเหลือ
        matchingSOItems.forEach((soItem) => {
          if (remainingWeight <= 0) return;

          const usedThisRun = usedPOMap.get(soItem.id) || 0;
          const alreadyUsed = soItem.actualWeight || 0;
          const availableWeight = isCommittedSale
            ? Math.max(0, committedSOWeightRemaining - usedThisRun)
            : soItem.unlimitedWeight
              ? Infinity
              : Math.max(0, (soItem.weight || 0) - (alreadyUsed + usedThisRun));
          if (availableWeight <= 0) return;

          const weightToUse = isCommittedSale
            ? Math.min(remainingWeight, availableWeight)
            : soItem.unlimitedWeight
            ? remainingWeight
            : Math.min(remainingWeight, availableWeight);
          const soPricePerUnit = Number(
            soItem?.pricePerUnit ?? soItem?.salePrice ?? 0,
          );

          breakdown.push({
            index,
            productId: item.productId,
            productName: item.productName,
            pricePerUnit: 0,
            PricePerUnit: soPricePerUnit,
            totalPrice: weightToUse * soPricePerUnit,
            usedWeight: weightToUse,
            priceSource: "so",
            soInfo: { ...soItem },
            basePrice: item.product?.price,
          });

          usedPOMap.set(soItem.id, usedThisRun + weightToUse);
          if (isCommittedSale) {
            committedSOWeightRemaining = Math.max(
              0,
              committedSOWeightRemaining - weightToUse,
            );
          }
          remainingWeight -= weightToUse;
        });

        // 3️⃣ ราคากลุ่ม ถ้ายังเหลือ
        if (remainingWeight > 0) {
          const extraPrice =
            item.insuranceExtraPrice == null
              ? Number(item.pricePerUnit || 0)
              : Number(item.insuranceExtraPrice);
          breakdown.push({
            index,
            productId: item.productId,
            productName: item.productName,
            pricePerUnit: extraPrice,
            PricePerUnit: 0,
            totalPrice: extraPrice * remainingWeight,
            usedWeight: remainingWeight,
            priceSource: "group",
            isGroupAdjustment: true,
            isInsuranceExtra: item.insuranceExtraPrice != null,
            basePrice: item.product?.price,
          });
        }

        breakdownList.push(...breakdown);
      });

      // Group breakdown
      const grouped = Object.values(
        breakdownList.reduce((acc, row) => {
          const key = row.index;
          const transactionItem = transaction.items[row.index];
          if (!acc[key]) {
            const impW =
              (transactionItem.impurities || []).reduce(
                (s, i) => s + N(i.weight),
                0
              ) +
              (transactionItem.deductedItems || []).reduce(
                (s, d) => s + N(d.weight2),
                0
              );

            acc[key] = {
              basePrice: transactionItem?.product?.price ?? 0,
              customerId: transaction.customerId,
              index: row.index,
              productId: row.productId,
              productName: row.productName,
              totalPrice: row.totalPrice || 0,
              usedWeight: row.usedWeight || 0,
              sources: [row.priceSource],
              details: [row],
              originalItem: transactionItem
                ? {
                  ...transactionItem,
                  netWeight:
                    N(transactionItem.weight) -
                    N(transactionItem.deductWeight) -
                    impW,
                }
                : null,
            };
          } else {
            acc[key].totalPrice += row.totalPrice || 0;
            acc[key].usedWeight += row.usedWeight || 0;
            acc[key].sources.push(row.priceSource);
            acc[key].details.push(row);
          }
          return acc;
        }, {})
      );

      // เติม item ที่ไม่มี breakdown (เช่น netWeight = 0) ให้ยังแสดงได้
      const ensureAllItems = (transaction.items || []).map(
        (transactionItem, index) => {
          const existing = grouped.find((g) => g.index === index);
          if (existing) return existing;

          const impW =
            (transactionItem.impurities || []).reduce(
              (s, i) => s + N(i.weight),
              0
            ) +
            (transactionItem.deductedItems || []).reduce(
              (s, d) => s + N(d.netWeight),
              0
            );
          const netWeight = Math.max(
            0,
            N(transactionItem.weight) - N(transactionItem.deductWeight) - impW
          );

          return {
            basePrice: transactionItem?.product?.price ?? 0,
            customerId: transaction.customerId,
            index,
            productId: transactionItem.productId,
            productName: transactionItem.productName,
            totalPrice: 0,
            usedWeight: 0,
            sources: [],
            details: [], // ไม่มีแหล่งราคา แต่ให้โชว์แถวได้
            originalItem: {
              ...transactionItem,
              netWeight,
            },
          };
        }
      );

      setTransactionBreakdown(ensureAllItems);
      // ยอดสุทธิต้องเปลี่ยนทันทีเมื่อเลือก/ยกเลิก SO
      // ไม่ต้องรอ fetchData รอบถัดไปหรือรีเฟรชหน้า
      setTotalNetPrice(
        ensureAllItems.reduce((sum, item) => sum + N(item.totalPrice), 0),
      );

      // สร้าง payload
      const payloads = ensureAllItems
        .filter((g) => g.originalItem?.id)
        .map((g) => {
          const soItemsForThisItem = soSelect
            .flatMap((so) => (so.items ? so.items : [so]))
            .filter((p) => p.productId === g.originalItem.productId);

          const singleSO =
            soItemsForThisItem.length === 1 ? soItemsForThisItem[0] : null;
          const soDetails = g.details.filter(
            (detail) => detail.priceSource === "so",
          );
          const totalSOUsedWeight = soDetails.reduce(
            (sum, detail) => sum + N(detail.usedWeight),
            0,
          );
          const soPricePerUnit = singleSO
            ? Number(singleSO.pricePerUnit ?? singleSO.salePrice ?? 0)
            : null;

          const groupSource = g.details.find((d) => d.priceSource === "group");
          const calculatedNetPrice = g.details.reduce(
            (sum, d) => sum + (d.totalPrice || 0),
            0,
          );
          const itemNetWeight = N(g.originalItem.netWeight);
          const hasSOPrice = soItemsForThisItem.length > 0 || soDetails.length > 0;
          // For items without SO pricing, persist the current weighted price.
          // This prevents a previous LockPricing/excess price from being used
          // by the PDF after the excess weight is removed.
          const pricePerUnit = hasSOPrice
            ? groupSource?.pricePerUnit ?? g.originalItem.pricePerUnit
            : itemNetWeight > 0
              ? calculatedNetPrice / itemNetWeight
              : g.originalItem.pricePerUnit;

          return {
            id: g.originalItem.id,
            productId: g.originalItem.productId,
            productName: g.originalItem.productName,
            pricePerUnit: pricePerUnit || 0,
            weight: g.originalItem.weight || 0,
            deductWeight: g.originalItem.deductWeight || 0,
            netWeight: g.originalItem.netWeight || 0,
            netPrice: calculatedNetPrice,
            soPricePerUnit,
            soUsedWeight: totalSOUsedWeight > 0 ? totalSOUsedWeight : null,
            insuranceExtraPrice:
              g.originalItem.insuranceExtraPrice == null
                ? null
                : Number(g.originalItem.insuranceExtraPrice),
            insuranceExtraPriceMode: g.originalItem.insuranceExtraPriceMode ?? null,
            saleOrderItemIds: soItemsForThisItem.map((p) => p.id),
            lockPricingAllocations: g.details
              .filter((detail) => detail.priceSource === "insurance")
              .map((detail) => ({ lockPricingId: detail.lockInfo.id, weight: detail.usedWeight, pricePerUnit: detail.pricePerUnit })),
          };
        });

      // รายการที่ส่งแล้วต้องคงน้ำหนัก SO ที่ถูกใช้จริงไว้ในตั๋ว
      // เพราะ actualWeight ของ SO จะลดน้ำหนักคงเหลือ ทำให้การคำนวณใหม่
      // อาจนำค่าคงเหลือ (เช่น 10 กก.) มาเขียนทับค่าที่ใช้จริง (เช่น 100 กก.)
      if (
        payloads.length > 0 &&
        String(transaction.status || "").toLowerCase() === "waiting"
      ) {
        try {
          const save = pricingSaveRef.current.catch(() => {}).then(() => services.updateSaleTransaction(
            { items: payloads }, transactionId,
          ));
          pricingSaveRef.current = save;
          await save;
          pricingSaveErrorRef.current = null;
        } catch (err) {
          pricingSaveErrorRef.current = err;
          toast.error(err?.response?.data?.error || "บันทึกราคาสินค้าไม่สำเร็จ กรุณาเลือกราคาใหม่");
          console.error("อัปเดต TransactionItem ไม่สำเร็จ:", err);
        }
      }
    };

    fetchDataAndCalculate();
  }, [transaction, soSelect, lockSelect, transactionId]);

  // Keep the detail modal in sync when an item is updated while it remains open.
  // The price edit flow refreshes the transaction, which rebuilds this breakdown
  // asynchronously; without syncing the selected row here the modal keeps the
  // object that was selected before the save.
  useEffect(() => {
    const selectedItemId = selectedItem?.originalItem?.id;
    if (!selectedItemId || !transactionBreakdown?.length) return;

    const latestItem = transactionBreakdown.find(
      (item) => item?.originalItem?.id === selectedItemId,
    );
    if (latestItem && latestItem !== selectedItem) {
      setSelectedItem(latestItem);
    }
  }, [transactionBreakdown, selectedItem]);

  const handleSubChange = (sub) => {
    setSubFilter(sub);
  };

  const handleChange = (event) => {
    const value = event.target ? event.target.value : event;
    setSubFilter("ทั้งหมด");
    setFilter(value);
  };

  const handleUpdate = async (value) => {
    const shouldCheckStock =
      transaction?.status === "waiting" &&
      (value === "sent" || value === "payed");

    if (shouldCheckStock) {
      try {
        const inventoryRes = await services.getInventory();
        const inventoryItems = inventoryRes?.data?.data ?? [];
        const stockByProduct = new Map(
          inventoryItems.map((item) => [item.productId, N(item.quantity)])
        );
        const requiredByProduct = new Map();

        (transaction?.items || []).forEach((item) => {
          const quantity = Math.max(0, N(item.netWeight));
          if (item?.productId == null || quantity <= 0) return;

          const current = requiredByProduct.get(item.productId) || {
            productId: item.productId,
            productName:
              item.productName || item.product?.title || `สินค้า #${item.productId}`,
            quantity: 0,
          };
          current.quantity += quantity;
          requiredByProduct.set(item.productId, current);
        });

        const insufficientItems = Array.from(requiredByProduct.values())
          .map((item) => ({
            ...item,
            stock: stockByProduct.get(item.productId) ?? 0,
          }))
          .filter((item) => item.stock < item.quantity);

        if (insufficientItems.length > 0) {
          const escapeHtml = (text) =>
            String(text).replace(
              /[&<>"']/g,
              (char) =>
                ({
                  "&": "&amp;",
                  "<": "&lt;",
                  ">": "&gt;",
                  '"': "&quot;",
                  "'": "&#039;",
                })[char]
            );
          const itemRows = insufficientItems
            .map(
              (item) => `
                <div style="display:flex;justify-content:space-between;gap:16px;padding:10px 0;border-bottom:1px solid #e2e8f0;text-align:left;">
                  <strong>${escapeHtml(item.productName)}</strong>
                  <span>ต้องใช้ ${formatNumber(item.quantity)} กก. / คงเหลือ ${formatNumber(item.stock)} กก.</span>
                </div>`
            )
            .join("");

          await Swal.fire({
            customClass: { container: "my-swal" },
            title: "สต๊อกสินค้าไม่เพียงพอ",
            html: `<div>${itemRows}</div>`,
            icon: "error",
            confirmButtonText: "ตกลง",
            confirmButtonColor: "#dc2626",
          });
          return;
        }
      } catch (error) {
        await Swal.fire({
          customClass: { container: "my-swal" },
          title: "ไม่สามารถตรวจสอบสต๊อกได้",
          text: "กรุณาลองใหม่อีกครั้ง",
          icon: "error",
          confirmButtonText: "ตกลง",
        });
        return;
      }
    }

    const isSending = value === "sent";
    const result = await Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: isSending ? "ยืนยันการส่งสินค้า" : "ยืนยันการดำเนินการ",
      text: isSending
        ? "คุณแน่ใจหรือไม่ที่จะบันทึกการส่งสินค้า"
        : "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      await pricingSaveRef.current;
      if (pricingSaveErrorRef.current) throw pricingSaveErrorRef.current;
      await services.updateSaleTransaction({ status: value }, transactionId);
      await fetchData();
      toast.success(`บันทึกสำเร็จ`);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "ไม่สามารถอัปเดตสถานะหรือสต๊อกได้";
      toast.error(message);
    }
  };

  const handleDestinationConfirm = async (destinationItems) => {
    await services.updateSaleTransaction(
      {
        status: "confirm",
        items: destinationItems,
      },
      transactionId
    );
    setOpenDestinationDialog(false);
    await fetchData();
    toast.success("บันทึกน้ำหนักและราคาปลายทางสำเร็จ");
  };

  const handleClose = async (value) => {
    setSelectedValue([]);
    setOpenProductDialog(false);
  };

  const handleDeleteItem = async (value) => {
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: `ยืนยันที่จะลบ${value.productName} ?`,
      text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await services.deleteItemSaleTransaction(transactionId, value.id);
          toast.success(`ลบรายการ ${value.productName} สำเร็จ`);
        } catch (err) {
          console.log("err: ", err);
        } finally {
          await fetchData();
          window.location.reload();

        }
      }
    });
  };

  const handleOpenSaleExtraPrice = (item) => {
    if (!canEditSaleItems) {
      toast.error("แก้ไขราคาน้ำหนักส่วนเกินได้เฉพาะตั๋วที่ยังไม่ส่ง");
      return;
    }
    setSelectedSaleExtraItem(item);
    setOpenSaleExtraPriceDialog(true);
  };

  const handleSaveSaleExtraPrice = async (payload) => {
    const itemId = selectedSaleExtraItem?.originalItem?.id;
    if (!itemId) return;
    const totalPrice =
      Number(payload.protectedTotal || 0) +
      Number(payload.extraWeight || 0) * Number(payload.pricePerUnit || 0);
    const totalWeight = Number(payload.totalWeight || 0);
    try {
      await services.updateSaleTransaction(
        {
          items: [
            {
              id: itemId,
              pricePerUnit: totalWeight > 0 ? totalPrice / totalWeight : Number(payload.pricePerUnit || 0),
              netPrice: totalPrice,
              insuranceExtraPrice: Number(payload.pricePerUnit || 0),
              insuranceExtraPriceMode: "custom",
            },
          ],
        },
        transactionId,
      );
      setOpenSaleExtraPriceDialog(false);
      setSelectedSaleExtraItem(null);
      await fetchData();
      toast.success("บันทึกราคาน้ำหนักส่วนเกินแล้ว");
    } catch (error) {
      console.error("บันทึกราคาน้ำหนักส่วนเกินไม่สำเร็จ:", error);
      toast.error(error?.response?.data?.error || "ไม่สามารถบันทึกราคาน้ำหนักส่วนเกินได้");
    }
  };

  const handleClick = (index) => {
    setSelectedPackage(null);
    setSelectedValue(index);
    setOpenStockTypeDialog(true);
  };

  const handleClickEdit = (value) => {
    const item = {
      itemId: value.id,
      title: value.productName,
      finalPrice: value.pricePerUnit,
      id: value.productId,
      weight: parseFloat(value.weight || 0),
      deduct: parseFloat(value.deductWeight || 0),
      netWeight: parseFloat(value.netWeight || 0),
      impurities: value.impurities,
      totalImpurityWeight: value.impurityWeight,
      deductedItems: value.deductedItems,
    };
    setSelectedValue(item);
    setOpenProductDialog(true);
  };

  const getLatestTransactionForPdf = async () => {
    await pricingSaveRef.current.catch(() => {});
    try {
      const response = await services.getSaleTransaction(transactionId);
      const latestTransaction = response?.data?.data;
      if (latestTransaction) {
        setTransaction(latestTransaction);
        return latestTransaction;
      }
    } catch (error) {
      console.error("โหลดข้อมูลล่าสุดก่อนสร้าง PDF ไม่สำเร็จ:", error);
    }
    return transaction;
  };

  const handleSelectPDF = async (select) => {
    const latestTransaction = await getLatestTransactionForPdf();
    if (select === "1") {
      generateDeliveryNotePdf(latestTransaction);
    } else if (select === "2") {
      generateDeliveryNoteSalePdf(latestTransaction);
    } else {
      generateInvoicePdf(latestTransaction);
    }
  };

  const handleSubmit = async (value) => {
    await pricingSaveRef.current.catch(() => {});
    const {
      title,
      id,
      weight,
      finalPrice,
      deduct,
      netWeight,
      impurities = [],
      deductedItems = [],
      snapshots,
      itemId,
      note,
    } = value;
    // ===== helpers =====
    const mapImgs = (arr = []) =>
      arr
        .filter((x) => x?.url)
        .map((x) => ({
          imageUrl: x.url,
          type: x?.label || x?.context?.type || "img",
          createdAt: x.at || null,
          meta: {
            at: x.at || null,
            label: x?.label || x?.context?.label,
            source: x?.context?.source,
            index: x?.context?.index,
            createdAt: x?.context?.createdAt,
            productId: x?.context?.productId,
            productName: x?.context?.productName,
            isDeductProduct: !!x?.context?.isDeductProduct,
          },
        }));
    setOpenProductDialog(false);
    const totalImpurityWeight = (impurities || []).reduce(
      (sum, it) => sum + N(it?.weight),
      0
    );
    const types = (impurities || [])
      .map((it) => it?.type || "")
      .filter(Boolean)
      .join(", ");
    const displayType = types ? `(${types})` : "";
    const impuritiesWithImgs = (impurities || []).map((it) => ({
      ...it,
      weight: N(it?.weight),
      images: mapImgs(it?.attachedImages || it?.images || []),
    }));
    const images = mapImgs(snapshots);
    const mainItem = {
      ...(itemId && { id: itemId }), // ใส่ id เฉพาะตอน update
      productName: title,
      pricePerUnit: finalPrice,
      weight: parseFloat(weight || 0),
      netWeight: parseFloat(netWeight || 0),
      netPrice: parseFloat((netWeight || 0) * (finalPrice || 0)),
      note,
      productId: id,
      deductWeight: deduct,
      impurityWeight: totalImpurityWeight,
      impurities: impuritiesWithImgs,
      impurityType: displayType,
      ...(images.length > 0 && { images }),
    };

    const res = await services.updateSaleTransaction(
      { items: [mainItem] },
      transactionId
    );
    const updatedMainItem = res?.data?.data?.items?.[0];
    if (!updatedMainItem?.id) {
      toast.error("ไม่สามารถอัปเดตรายการหลักได้");
      return;
    }

    // (2) เตรียม deductedItems — แนบรูปเฉพาะที่ผูกกับแถว
    const additionalItems = (deductedItems || []).map((it) => {
      const w = N(it?.weight ?? it?.weight2);
      const p = N(it?.price ?? it?.pricePerUnit);
      const itemImgs = mapImgs(it?.attachedImages || it?.images || []);
      const isUpdate = !!it?.id;

      const base = {
        id: it?.id,
        sourceItemId: updatedMainItem.id,
        productName: it?.title ?? it?.productName ?? "",
        productId: it?.productId,
        pricePerUnit: 0,
        isLockedPrice: false,
        deductWeight: 0,
        impurityWeight: 0,
        impurities: [],
        impurityType: "",
        usedWeight: null,
        createdAt: it?.createdAt,
        ...(itemImgs.length > 0 && { images: itemImgs }),
      };

      if (isUpdate) return { ...base, weight2: w };
      return {
        ...base,
        weight: w,
        weight2: w,
        netWeight: w,
        netPrice: 0,
      };
    });

    // Remove deducted-product rows that were deleted while editing the item.
    // Leaving these rows in the transaction makes the next GET (and therefore
    // the PDF) include the old excess weight again.
    const previousDeductedIds = new Set(
      (selectedValue?.deductedItems || [])
        .map((item) => Number(item?.id))
        .filter((id) => Number.isInteger(id) && id > 0),
    );
    const submittedDeductedIds = new Set(
      (deductedItems || [])
        .map((item) => Number(item?.id))
        .filter((id) => Number.isInteger(id) && id > 0),
    );
    const removedDeductedIds = [...previousDeductedIds].filter(
      (id) => !submittedDeductedIds.has(id),
    );
    for (const removedId of removedDeductedIds) {
      await services.deleteItemSaleTransaction(transactionId, removedId);
    }

    // (3) สร้าง/อัปเดต deducted ที่เหลือ
    if (additionalItems.length > 0) {
      await services.updateSaleTransaction(
        { items: additionalItems },
        transactionId
      );
    }

    toast.success(`บันทึกรายการ ${title ?? ""} สำเร็จ`);
    // if (mode === "create" && selectedPackage) {
    //   const res2 = await services.deletePackage(selectedPackage.id);
    //   console.log("res2", res2);
    // }

    // toast.success(
    //   `${mode === "create" ? "เพิ่ม" : "บันทึก"}รายการ ${title} สำเร็จ`
    // );

    setSelectedValue([]);
    await fetchData();
  };

  const handleChangeCustomer = async (customer) => {
    setOpenCustomerPickerDialog(false);

    const currentCustomerId = transaction.customerId;
    const newCustomerId = customer?.customer?.id;

    const payload = {
      customerId: newCustomerId,
      customerName: customer?.customer?.name ?? null,
      carId: customer?.car?.id ?? null,
      driverId: customer?.driver?.id ?? null,
    };

    await services.updateSaleTransaction(payload, transactionId);

    if (currentCustomerId === newCustomerId) {
      await fetchData();
      return;
    }

    try {
      // เตรียมอัพเดตราคาใหม่ + ล้าง PO ของทุก item แบบ batch ในครั้งเดียว
      // ดึงราคากลุ่ม (basePrice + groupAdjustment) แบบ parallel
      const items = transaction?.items || [];

      const pricedItems = await Promise.all(
        items.map(async (item) => {
          try {
            const res = await services.getProductPrice({
              customerId: newCustomerId,
              productId: item.productId,
            });
            const data = res?.data?.data || {};
            const newPrice =
              (data.basePrice ?? 0) + (data.groupAdjustment ?? 0);

            return {
              id: item.id,
              // ราคาใหม่ตามกลุ่มของลูกค้าใหม่
              pricePerUnit: newPrice,
              // ล้าง PO ที่เคยผูกไว้กับ item นี้
              poId: null,
              usedWeight: null,
              poPricePerUnit: null,
            };
          } catch (e) {
            console.error("getProductPrice failed for item", item.id, e);
            // ถ้าดึงราคาไม่สำเร็จ ก็ยังล้าง PO ออก แต่คงราคาเดิมไว้
            return {
              id: item.id,
              pricePerUnit: item.pricePerUnit ?? 0,
              poId: null,
              usedWeight: null,
              poPricePerUnit: null,
            };
          }
        })
      );

      // updateTransaction ครั้งเดียวด้วย items ทั้งชุด
      await services.updateSaleTransaction(
        { items: pricedItems },
        transactionId
      );

      // เคลียร์ state PO ที่เลือกไว้ (กันงง)
      // setPoSelect([]);

      toast.success("เปลี่ยนลูกค้าเรียบร้อย");
      await fetchData();
    } catch (err) {
      console.error("Error handleChangeCustomer:", err);
      toast.error("อัปเดตราคา/ล้าง PO ไม่สำเร็จ");
    }
  };
  const VAT_RATE = 0.07;
  const taxOption = transaction?.customer?.salesTaxOption; // 'vatExcluded' | 'vatIncluded' | (อื่นๆ = ไม่มี VAT)

  const baseAmountRaw = totalNetPrice;

  let beforeVat, vatAmt, grand;

  if (taxOption === "vatExcluded") {
    // ราคา "ยังไม่รวม VAT" => เอา VAT บวกเข้าไป
    beforeVat = baseAmountRaw;
    vatAmt = beforeVat * VAT_RATE;
    grand = beforeVat + vatAmt;
  } else if (taxOption === "vatIncluded") {
    // ราคา "รวม VAT มาแล้ว" => ดึง VAT ออก
    grand = baseAmountRaw;
    vatAmt = (grand * VAT_RATE) / (1 + VAT_RATE);
    beforeVat = grand - vatAmt;
  } else {
    // ไม่มี VAT
    beforeVat = baseAmountRaw;
    vatAmt = 0;
    grand = beforeVat;
  }

  const handleShippingSubmit = async (shipping) => {
    await services.updateSaleTransaction(
      {
        carId: shipping.carId,
        driverId: shipping.driverId,
        shipping: {
          purchaseOrderNumber: shipping.purchaseOrderNumber || null,
          shippingName: shipping.shippingName || null,
          driverName: shipping.driverName || null,
          vehicleNumber: shipping.vehicleNumber || null,
          phoneNumber: shipping.phoneNumber || null,
          note: shipping.note,
        },
      },
      transactionId
    );
    setOpenShippingDialog(false);
    fetchData();
    toast.success("อัพเดทข้อมูลการขนส่งเรียบร้อย");
  };
  function summarizeDeductions() {
    const items = transaction?.items || [];

    const sumDeducted = items
      .flatMap((it) => it.deductedItems || [])
      .reduce((s, d) => s + (Number(d.weight) || 0), 0);

    let sumDiscard = 0,
      sumReturn = 0,
      sumConvert = 0;

    for (const it of items) {
      for (const im of it.impurities || []) {
        const w = Number(im.weight) || 0;
        const kind = im.kind || "discard"; // ถ้าไม่มี kind ให้ถือว่าเป็น "หักทิ้ง"

        if (kind === "discard") {
          sumDiscard += w;
        } else if (kind === "return") {
          sumReturn += w;
        } else if (kind === "convert") {
          sumConvert += w;
        }
      }
    }

    const parts = [];
    if (sumDeducted > 0)
      parts.push(`หักเป็นสินค้าอื่น ${formatNumber(sumDeducted)}`);
    if (sumDiscard > 0) parts.push(`หักทิ้ง ${formatNumber(sumDiscard)}`);
    if (sumReturn > 0) parts.push(`หักคืน ${formatNumber(sumReturn)}`);
    if (sumConvert > 0)
      parts.push(`แปลงเป็นสินค้าอื่น ${formatNumber(sumConvert)}`);

    return parts.length > 0 ? `(${parts.join(", ")})` : "";
  }
  return (
    <>
      <Toaster position="bottom-right" reverseOrder={false} />
      <div className="h-screen bg-slate-50/50 flex flex-col overflow-hidden">
        <div className="p-4 pb-0 flex-none">
          <AppBreadcrumbs />
        </div>

        <div className="flex-1 min-h-0 grid grid-cols-12 gap-6 p-4">
          <div className="col-span-12 lg:col-span-6 flex flex-col min-h-0 gap-6">
            <div className="bg-white rounded-3xl p-6 shadow-sm border border-slate-100 flex flex-col flex-1 min-h-0 overflow-hidden">
              {/* ส่วนหัว */}
              {/* หัวตั๋ว: ข้อมูลลูกค้า (Redesigned - Compact) */}
              {transaction && (
                <div className="mb-3">
                  <div
                    onClick={() => setOpenCustomerPickerDialog(true)}
                    className="bg-cyan-50/50 rounded-xl p-2.5 border border-cyan-100/50 flex items-center justify-between cursor-pointer hover:bg-cyan-100/70 transition-all group/customer"
                  >
                    <div className="flex items-center gap-2.5">
                      <Avatar
                        sx={{
                          width: 40,
                          height: 40,
                          bgcolor: "slate.300",
                          fontSize: "1.25rem",
                          fontWeight: "bold",
                        }}
                      >
                        {transaction.customer?.customerGroup?.name?.[0] || "A"}
                      </Avatar>
                      <div className="flex flex-col">
                        <div className="flex items-center gap-1 flex-wrap">
                          <span className="font-bold text-slate-800 text-[16px]">
                            ชื่อ : {transaction?.customer?.name}
                          </span>
                          <span className="text-slate-500 text-xs font-medium ml-1">
                            {transaction?.car?.license}
                            {transaction?.car?.province
                              ? ` (${transaction.car.province})`
                              : ""}
                          </span>
                          <div className="text-slate-300 group-hover/customer:text-blue-500 transition-colors ml-1">
                            <EditIcon sx={{ fontSize: 16 }} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenShippingDialog(true);
                        }}
                        className="p-2 rounded-lg bg-white border border-slate-200 text-slate-400 hover:bg-blue-50 hover:text-blue-500 transition-all shadow-sm flex items-center justify-center w-10 h-10"
                      >
                        <LocalShippingIcon sx={{ fontSize: 18 }} />
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenSOSelectionDialog(true);
                        }}
                        className="p-2 rounded-lg bg-white border border-slate-200 text-slate-400 hover:bg-amber-50 hover:text-amber-600 transition-all shadow-sm flex items-center justify-center w-10 h-10"
                      >
                        <TuneIcon sx={{ fontSize: 18 }} />
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* กล่องแสดง Items (Redesigned - Compact) */}
              <div className="flex-1 overflow-y-auto min-h-0 pr-2 space-y-3 custom-scrollbar">
                {transactionBreakdown?.length ? (
                  transactionBreakdown
                    .filter(
                      (item) =>
                        item.originalItem && item.originalItem.id != null
                    )
                    .map((item, index) => {
                      const soNumbers = Array.from(
                        new Set(
                          (item?.details || [])
                            .filter((detail) => detail.priceSource === "so")
                            .map((detail) => {
                              const soNumber =
                                detail?.soInfo?.saleOrder?.soNumber ??
                                detail?.soInfo?.soNumber;
                              if (soNumber) return String(soNumber).split("-").pop();

                              const id =
                                detail?.soInfo?.saleOrderId ??
                                detail?.soInfo?.saleOrder?.id ??
                                detail?.soInfo?.id;
                              return id != null
                                ? String(id).padStart(4, "0")
                                : null;
                            })
                            .filter((soNumber) => soNumber != null),
                        ),
                      );
                      return (
                        <div
                          key={index}
                          onClick={() => {
                            if (canEditSaleItems) {
                              handleClickEdit(item?.originalItem || item);
                            }
                          }}
                          className={`group relative bg-white border border-slate-200 rounded-xl transition-all duration-200 ${canEditSaleItems
                            ? "cursor-pointer hover:border-blue-200 hover:shadow-sm"
                            : "cursor-default"
                            } ${transaction?.status === "cancel" ? "opacity-75" : ""}`}
                        >
                          <div className="flex p-3">
                            <div className="flex-1 min-w-0">
                              {/* Header Row: Title & Price Pill */}
                              <div className="flex justify-between items-start mb-2">
                                <div className="flex items-center gap-2">
                                  <span className="text-[17px] font-bold text-slate-800">
                                    {index + 1}. {item?.productName}
                                  </span>
                                  {canEditSaleItems && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleClickEdit(item?.originalItem);
                                      }}
                                      className="text-slate-300 hover:text-blue-500 transition-colors"
                                    >
                                      <EditIcon sx={{ fontSize: 16 }} />
                                    </button>
                                  )}
                                </div>

                                {hasPermission(["show_price_in_ticket"]) && (
                                  <div className="relative pt-1.5">
                                    <div className="flex items-center gap-1.5 p-1.5 px-3 rounded-xl bg-emerald-50 border border-emerald-100/60 text-emerald-600 shadow-sm shadow-emerald-50/50">
                                      <div className="flex items-center gap-1.5 opacity-80">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                                          <path d="M4.5 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM14.25 8.625a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM17.25 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122V19.125Z" />
                                        </svg>
                                        <span className="text-[15px] font-black tracking-tight leading-none">
                                          {formatNumber(
                                            item?.usedWeight > 0
                                              ? item.totalPrice / item.usedWeight
                                              : item?.originalItem?.pricePerUnit ?? 0,
                                          )}
                                        </span>
                                      </div>
                                      <span className="text-[10px] font-bold opacity-60 ml-px">บ./กก.</span>
                                    </div>
                                  </div>
                                )}
                              </div>

                              {/* Weights Breakdown Line (Consolidated) */}
                              <div className="flex justify-between items-baseline mb-1">
                                <div className="flex gap-4 text-slate-400 text-[16px] font-medium">
                                  <div className="flex gap-1.5">
                                    <span>รวมน้ำหนัก:</span>
                                    <span className="font-black text-slate-700">{formatNumber(item?.originalItem?.weight)}</span>
                                  </div>
                                  <div className="flex gap-1.5">
                                    <span>หัก:</span>
                                    <span className="font-black text-slate-700">{formatNumber(item?.originalItem?.deductWeight)}</span>
                                  </div>
                                  <div className="flex gap-1.5">
                                    <span className="opacity-60">สิ่งเจือปน:</span>
                                    <span className="font-black text-slate-700">{formatNumber(item?.originalItem?.impurityWeight)}</span>
                                  </div>
                                </div>

                                <div className="flex items-center gap-2">
                                  <span className="text-slate-300 font-bold">=</span>
                                  <span className="text-[18px] font-black text-slate-800 tracking-tight">
                                    {formatNumber(item?.originalItem?.netWeight)}
                                  </span>
                                </div>
                              </div>

                              {soNumbers.length > 0 && (
                                <div className="text-sm font-semibold text-amber-600">
                                  สินค้านี้ใช้ราคา SO เลขที่ {soNumbers.join(", ")}
                                </div>
                              )}

                              {/* Footer Summary: Total Price (Right Aligned) */}
                              {hasPermission(["show_price_in_ticket"]) && (
                                <div className="flex justify-end items-center mt-2 pt-1 border-t border-slate-50/50">
                                  <div className="flex items-baseline gap-2">
                                    <span className="text-[13px] font-bold text-slate-400">รวมเงิน</span>
                                    <span className="text-[22px] font-black text-slate-900 tracking-tighter">
                                      {formatNumber(item.totalPrice)}
                                    </span>
                                    <span className="text-[13px] font-bold text-slate-400">บาท</span>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Actions Column (Side) */}
                            <div className="flex flex-col gap-2 pl-3 ml-3 border-l border-slate-50">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteItem(item.originalItem);
                                }}
                                disabled={!canEditSaleItems}
                                className="text-rose-400 hover:text-rose-600 transition-colors disabled:opacity-20"
                              >
                                <DeleteIcon sx={{ fontSize: 18 }} />
                              </button>
                              <div className="relative">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedImage([item?.originalItem?.images[item?.originalItem?.images.length - 1]]);
                                    setImageList(item?.originalItem?.images);
                                    setImageDetail(item?.originalItem);
                                    setOpenImg(true);
                                    setType("item");
                                  }}
                                  disabled={!item?.originalItem?.images?.length}
                                  className={`transition-colors ${item?.originalItem?.images?.length ? "text-slate-300 hover:text-blue-500" : "text-slate-200"}`}
                                >
                                  <ImageIcon sx={{ fontSize: 18 }} />
                                </button>
                                {item?.originalItem?.images?.length > 0 && (
                                  <span className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 bg-rose-500 text-white text-[9px] font-black rounded-full ring-2 ring-white">
                                    {item?.originalItem?.images.length}
                                  </span>
                                )}
                              </div>

                              {item?.details?.some(
                                (detail) => ["so", "insurance"].includes(detail.priceSource),
                              ) && (
                                <div className="relative">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedItem(item);
                                      setOpenItemDialog(true);
                                    }}
                                    className="text-slate-300 hover:text-amber-500 transition-colors"
                                    title="รายละเอียดราคาสินค้า"
                                  >
                                    <ChecklistIcon sx={{ fontSize: 18 }} />
                                  </button>
                                  <span className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 bg-amber-500 text-white text-[9px] font-black rounded-full ring-2 ring-white">
                                    {item.details.filter(
                                      (detail) => ["so", "insurance"].includes(detail.priceSource),
                                    ).length}
                                  </span>
                                </div>
                              )}

                            </div>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div className="h-full flex flex-col items-center justify-center text-slate-300 gap-3 opacity-60 py-12">
                    <DescriptionIcon sx={{ fontSize: 64 }} />
                    <span className="text-lg font-bold">ยังไม่มีรายการสินค้า</span>
                  </div>
                )}
              </div>

              {/* ส่วนท้าย: ข้อมูลน้ำหนักรถ (Redesigned - Compact) */}
              <div className="mt-4">
                <div
                  onClick={() => setOpenCarDialog(true)}
                  className="bg-white border-2 border-slate-100 rounded-2xl p-3 shadow-sm cursor-pointer hover:border-blue-200 hover:shadow-md transition-all group/carcard"
                >
                  {/* Header Title with Edit Icon (Refined) */}
                  <div className="flex items-center gap-2 mb-2 px-1">
                    <div className="p-1 px-1.5 bg-slate-100 rounded text-slate-500">
                      <ChecklistIcon sx={{ fontSize: 16 }} />
                    </div>
                    <span className="font-black text-slate-700 text-[16px]">น้ำหนักรถ</span>
                    <button
                      onClick={() => setOpenCarDialog(true)}
                      className="text-slate-300 hover:text-blue-500 transition-colors ml-1"
                    >
                      <EditIcon sx={{ fontSize: 16 }} />
                    </button>
                    <div className="ml-auto">
                      <button
                        onClick={(e) => e.stopPropagation()}
                        className="bg-rose-500 text-white px-4 py-1 rounded-xl text-[13px] font-black shadow-lg shadow-rose-200 active:scale-95 transition-all"
                      >
                        ชั่งรถเสร็จ
                      </button>
                    </div>
                  </div>

                  {/* Weight Data Grid (Refined Horizontal Layout) */}
                  <div className="flex gap-1.5">
                    <div className="flex items-center justify-between flex-1 bg-slate-50/50 border border-slate-100/50 rounded-xl p-2.5 h-11 px-3 group-hover/carcard:bg-slate-100/50 transition-colors">
                      <span className="text-[14px] font-bold text-slate-400">รถหนัก</span>
                      <span className="text-[18px] font-black text-slate-800 tracking-tight">
                        {formatNumber(transaction?.carHeavyWeight)}
                      </span>
                    </div>

                    <div className="flex items-center justify-between flex-1 bg-slate-50/50 border border-slate-100/50 rounded-xl p-2.5 h-11 px-3 group-hover/carcard:bg-slate-100/50 transition-colors">
                      <span className="text-[14px] font-bold text-slate-400">รถเบา</span>
                      <span className="text-[18px] font-black text-slate-800 tracking-tight">
                        {formatNumber(transaction?.carLightWeight)}
                      </span>
                    </div>

                    <div className="flex items-center justify-between flex-[1.2] bg-blue-50/80 border border-blue-100 rounded-xl p-2.5 h-11 px-3 group-hover/carcard:bg-blue-100/50 transition-colors">
                      <span className="text-[15px] font-bold text-blue-500">สุทธิ</span>
                      <span className="text-[20px] font-black text-blue-700 tracking-tight">
                        {formatNumber(transaction?.carHeavyWeight - transaction?.carLightWeight)}
                      </span>
                    </div>

                    <div className="shrink-0 relative">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedImage([transaction?.images?.[transaction?.images.length - 1]]);
                          setImageList(transaction?.images);
                          setImageDetail(transaction);
                          setOpenImg(true);
                          setType("car");
                        }}
                        disabled={!(transaction?.images?.length > 0)}
                        className={`h-full px-3 rounded-xl transition-all border flex items-center justify-center ${transaction?.images?.length > 0
                          ? "bg-white border-blue-200 text-blue-500 hover:bg-blue-50 hover:border-blue-300 shadow-sm"
                          : "bg-slate-50 border-slate-100 text-slate-300 cursor-default"
                          }`}
                      >
                        <ImageIcon className="!text-xl" />
                      </button>
                      {transaction?.images?.length > 0 && (
                        <span className="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 bg-rose-500 text-white text-[10px] font-black rounded-full ring-2 ring-white shadow-sm z-10">
                          {transaction.images.length}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Weight Summary Box (Restored and Refined) */}
                  <div className="mt-2 bg-white border border-slate-100/80 rounded-xl p-2.5 shadow-inner">
                    <div className="flex items-baseline gap-2.5 mb-1.5 pb-1.5 border-b border-slate-50">
                      <span className="text-[16px] font-bold text-slate-400">น้ำหนักสุทธิ</span>
                      <span className="text-[18px] font-black text-slate-800 tracking-tight">
                        {formatNumber(totalNetWeight)}
                      </span>
                      <span className="text-slate-400 text-[16px] font-bold">กก.</span>
                      <span className="mx-1 text-slate-200 text-xs">|</span>
                      <span className="text-[16px] font-bold text-slate-400">น้ำหนักรถ</span>
                      <span className="text-[18px] font-black text-slate-800 tracking-tight">
                        {formatNumber(transaction?.carHeavyWeight - transaction?.carLightWeight)}
                      </span>
                      <span className="text-slate-400 text-[10px]">กก.</span>
                      <span className="text-slate-400 text-[18px] ml-0.5 font-bold text-slate-300">({formatNumber(totalImpurityWeight)})</span>
                    </div>

                    <div className="flex items-center gap-3.5 text-slate-400 text-[16px] font-medium">
                      <div className="flex items-center gap-1">
                        <span>รวม:</span>
                        <span className="font-black text-slate-700">{formatNumber(totalWeight)}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <span>หัก:</span>
                        <span className="font-black text-slate-700">{formatNumber(totalDeductWeight)}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="text-slate-300 text-[16px]">สิ่งเจือปน:</span>
                        <span className="font-black text-slate-700">{formatNumber(totalImpurityWeight)}</span>
                      </div>
                    </div>
                  </div>


                </div>
              </div>

              {/* สรุปราคารวม (Redesigned - Compact) */}
              {hasPermission(["show_price_in_ticket"]) && (
                <div className="mt-3 bg-[#0a0f18] text-white rounded-2xl p-4 shadow-xl relative overflow-hidden border border-slate-800">
                  <div className="relative z-10 flex flex-col gap-2">
                    {/* Before VAT & VAT Row (Refined Stripe) */}
                    <div className="flex items-center justify-start gap-6 text-slate-400 text-[16px] font-bold uppercase tracking-widest bg-slate-900/40 p-2.5 px-4 rounded-xl border border-white/5">
                      <div className="flex items-baseline gap-2">
                        <span >ก่อนภาษี</span>
                        <span className="text-white text-[16px] tracking-tight font-black">{formatNumber(beforeVat)}</span>
                      </div>
                      <div className="w-px h-3.5 bg-slate-800 self-center"></div>
                      <div className="flex items-baseline gap-2">
                        <span >ภาษี (7%)</span>
                        <span className="text-rose-500 text-[16px] tracking-tight font-black">{formatNumber(vatAmt)}</span>
                      </div>
                    </div>
                    {/* Grand Total Row (Refined Below) */}
                    <div className="flex justify-between items-center mt-1 px-1">
                      <span className="text-blue-400 font-black text-[18px] uppercase tracking-tighter">ยอดสุทธิ</span>
                      <div className="flex items-baseline gap-1.5">
                        <span className="text-[28px] font-black text-white tracking-tighter leading-none text-right">
                          {formatNumber(grand)}
                        </span>
                        <span className="text-blue-400 font-black text-[14px]">บาท</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Right Column: Categories, Product Grid, Action Pad */}
          <div className="col-span-12 lg:col-span-6 flex flex-col min-h-0 gap-4">
            <div className="bg-white rounded-3xl shadow-sm border border-slate-200/60 flex flex-col flex-1 min-h-0 overflow-hidden">

              {/* Top Bar: Categories OR Documents */}
              {showConfirmedSaleView ? (
                <div className="p-3 border-b border-slate-100 flex gap-2 overflow-x-auto whitespace-nowrap hide-scrollbar bg-slate-50/50">
                  <span className="flex items-center px-4 font-bold text-slate-700 bg-white border border-slate-200 rounded-xl mr-2 shadow-sm shrink-0">
                    เอกสารประกอบการขาย
                  </span>
                  <button
                    className="px-6 py-2 rounded-xl text-[16px] font-bold transition-all flex items-center justify-center shadow-sm bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-100 shrink-0"
                    onClick={async () => {
                      const latestTransaction = await getLatestTransactionForPdf();
                      const blob = await generateDeliveryNotePdfBlob(latestTransaction);
                      setPdfFromBlob(blob);
                    }}
                  >
                    รายการสินค้า
                  </button>
                  <button
                    className="px-6 py-2 rounded-xl text-[16px] font-bold transition-all flex items-center justify-center shadow-sm bg-blue-50 text-blue-600 border border-blue-200 hover:bg-blue-100 shrink-0"
                    onClick={async () => {
                      const latestTransaction = await getLatestTransactionForPdf();
                      const blob = await generateDeliveryNoteSalePdfBlob(latestTransaction);
                      setPdfFromBlob(blob);
                    }}
                  >
                    ใบขนส่งสินค้า
                  </button>
                  <button
                    className="px-6 py-2 rounded-xl text-[16px] font-bold transition-all flex items-center justify-center shadow-sm bg-amber-50 text-amber-600 border border-amber-200 hover:bg-amber-100 shrink-0"
                    onClick={async () => {
                      const latestTransaction = await getLatestTransactionForPdf();
                      const blob = await generateInvoicePdfBlob(latestTransaction);
                      setPdfFromBlob(blob);
                    }}
                  >
                    ใบแจ้งหนี้
                  </button>
                </div>
              ) : (
                <div className="p-3 border-b border-gray-100 overflow-x-auto whitespace-nowrap hide-scrollbar flex gap-2">
                  {categories.map((name, index) => (
                    <button
                      key={index}
                      onClick={() => handleChange({ target: { value: name } })}
                      className={`px-6 py-3 rounded-2xl text-[18px] font-black transition-all flex border items-center justify-center shadow-sm ${filter === name
                        ? "bg-blue-600 text-white shadow-blue-200 border-blue-600"
                        : "bg-slate-50 text-slate-600 hover:bg-slate-100 border-gray-100"
                        }`}
                    >
                      {name}
                    </button>
                  ))}
                </div>
              )}

              {/* SubCategories */}
              {subCategories.length > 0 && !showConfirmedSaleView && (
                <div className="px-3 py-2 border-b border-gray-50 overflow-x-auto whitespace-nowrap hide-scrollbar flex gap-2 bg-slate-50/50">
                  <button
                    onClick={() => handleSubChange("ทั้งหมด")}
                    disabled={transaction?.status === "payed" || transaction?.status === "confirm"}
                    className={`px-4 py-2 rounded-xl text-[14px] font-bold transition-all ${subFilter === "ทั้งหมด"
                      ? "bg-slate-800 text-white shadow-md"
                      : "bg-white text-slate-600 border border-slate-200 hover:bg-slate-100"
                      }`}
                  >
                    ทั้งหมด
                  </button>
                  {subCategories.map((sub, index) => (
                    <button
                      key={index}
                      onClick={() => handleSubChange(sub)}
                      disabled={transaction?.status === "payed" || transaction?.status === "confirm"}
                      className={`px-4 py-2 rounded-xl text-[14px] font-bold transition-all ${subFilter === sub
                        ? "bg-slate-800 text-white shadow-md"
                        : "bg-white text-slate-600 border border-slate-200 hover:bg-slate-100"
                        }`}
                    >
                      {sub}
                    </button>
                  ))}
                </div>
              )}


              {/* Center Area: PDF Viewer OR Product Grid */}
              <div className="flex-1 overflow-y-auto p-4 bg-gray-50/30">
                {showConfirmedSaleView ? (
                  <>
                    {pdfUrl ? (
                      <div className="w-full h-full border border-slate-200 rounded-2xl overflow-hidden bg-white shadow-inner">
                        <iframe
                          src={pdfUrl}
                          title="เอกสาร"
                          className="w-full h-full border-none block"
                        />
                      </div>
                    ) : (
                      <div className="w-full h-full flex flex-col items-center justify-center text-slate-400 font-medium bg-white border border-slate-200 rounded-2xl gap-2 shadow-sm">
                        <DescriptionIcon sx={{ fontSize: 48, opacity: 0.3 }} />
                        เลือกเอกสารจากตัวเลือกด้านบนเพื่อแสดง
                      </div>
                    )}
                  </>
                ) : (
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">

                    {cards
                      .filter((card) => {
                        if (isSpacerCard(card)) return true;
                        const passCat = filter === "ทุกประเภท" || card?.category?.name === filter;
                        if (!passCat) return false;
                        if (subFilter === "ทั้งหมด") return true;
                        return card?.subCategory?.name === subFilter;
                      })
                      .map((card, index) => {
                        if (isSpacerCard(card)) {
                          return (
                            <div
                              key={card.spacerId ?? index}
                              className="h-20 p-2 rounded-xl border-2 border-dashed border-slate-300 bg-slate-200/90 flex items-center justify-center text-slate-500 font-black text-lg select-none"
                            >
                              ช่องว่าง
                            </div>
                          );
                        }

                        return (
                          <button
                            key={card.productId ?? index}
                            onClick={() => handleClick(card)}
                            disabled={transaction?.status === "payed"}
                            style={{ backgroundColor: card?.subCategory.color ?? "#f1f5f9" }}
                            className={`h-20 p-2 rounded-xl transition-all shadow-sm hover:shadow-md text-center flex items-center justify-center group relative overflow-hidden ${transaction?.status === "payed"
                              ? "opacity-40 cursor-not-allowed"
                              : "hover:scale-[1.02] active:scale-95 border border-black/5"
                              }`}
                          >
                            <span
                              className="font-black text-[18px] z-10 leading-snug px-1 drop-shadow-sm"
                              style={{ color: getContrastColor(card?.subCategory.color ?? "#f1f5f9") }}
                            >
                              {card.title}
                            </span>
                            <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity" />
                          </button>
                        );
                      })}
                  </div>
                )}
              </div>

              {/* Action Pad Area & Notes */}
              <div className="p-4 bg-gray-50 border-t border-gray-100 flex flex-col gap-4">

                <div>
                  <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5 ml-1">
                    หมายเหตุตั๋ว
                  </label>
                  <input
                    type="text"
                    placeholder="เพิ่มหมายเหตุที่นี่..."
                    className="w-full text-sm py-3 px-4 rounded-xl border border-gray-200 bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-50 transition-all outline-none"
                    value={note || ""}
                    onChange={handleNoteChange}
                    disabled={transaction?.status === "cancel"}
                  />
                </div>

                {transaction?.status === "waiting" && (
                  <div className="grid grid-cols-3 gap-3">
                    {/* Row 1 */}
                    <button
                      onClick={() => handleUpdate("sent")}
                      className="col-span-1 h-20 bg-slate-800 text-white rounded-2xl font-black text-lg shadow-lg shadow-slate-200 hover:bg-slate-900 active:scale-95 transition-all flex items-center justify-center gap-2"
                    >
                      ส่งและยืนยันน้ำหนัก
                    </button>

                    <button
                      onClick={() => handleUpdate("payed")}
                      className="col-span-1 h-20 bg-emerald-600 text-white rounded-2xl font-black text-lg shadow-lg shadow-emerald-100 hover:bg-emerald-700 active:scale-95 transition-all flex items-center justify-center gap-2"
                    >
                      ส่งและรับเงิน
                    </button>

                    <button
                      onClick={() => setOpenPrintDialog(true)}
                      disabled={!hasPermission(["Print"])}
                      className="col-span-1 h-20 bg-white text-slate-800 rounded-2xl font-black text-lg shadow-sm border border-gray-200 hover:bg-gray-50 active:scale-95 transition-all disabled:opacity-50 disabled:bg-slate-50 flex items-center justify-center gap-2"
                    >
                      <PrintIcon />
                      พิมพ์ A4
                    </button>

                    {/* Row 2 */}
                    <div className="col-span-3 grid grid-cols-2 gap-3">
                      <button
                        onClick={() => (window.location.href = "/sale")}
                        className="col-span-1 h-14 bg-white text-slate-800 rounded-2xl font-black text-sm border border-gray-200 hover:bg-gray-50 active:scale-95 transition-all shadow-sm"
                      >
                        ปิดหน้าตั๋ว
                      </button>

                      <button
                        onClick={() => handleUpdate("cancel")}
                        disabled={!hasPermission(["purchase_cancel_ticket"])}
                        className="col-span-1 h-14 bg-rose-50 text-rose-500 rounded-2xl font-black text-sm border border-rose-100 hover:bg-rose-100 transition-all disabled:opacity-30 shadow-sm"
                      >
                        ยกเลิกตั๋ว
                      </button>
                    </div>
                  </div>
                )}

                {transaction?.status === "sent" && (
                  <div className="flex flex-col gap-3">
                    <div className="grid grid-cols-2 gap-3">
                      <button
                        onClick={() => setOpenPrintDialog(true)}
                        disabled={!hasPermission(["Print"])}
                        className="col-span-1 h-20 bg-slate-800 text-white rounded-2xl font-black text-lg shadow-lg hover:bg-slate-900 active:scale-95 transition-all"
                      >
                        พิมพ์ A4
                      </button>

                      <button
                        onClick={() => setOpenDestinationDialog(true)}
                        className="col-span-1 h-20 bg-amber-500 text-white rounded-2xl font-black text-lg shadow-lg shadow-amber-100 hover:bg-amber-600 active:scale-95 transition-all"
                      >
                        ยืนยันน้ำหนักสินค้า
                      </button>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <button
                        onClick={() => (window.location.href = "/sale")}
                        className="col-span-1 h-14 bg-white text-slate-800 rounded-2xl font-black text-sm border border-gray-200 hover:bg-gray-50 transition-all"
                      >
                        ปิดหน้าตั๋ว
                      </button>

                      <button
                        onClick={() => handleUpdate("waiting")}
                        className="col-span-1 h-14 bg-rose-50 text-rose-500 rounded-2xl font-black text-sm border border-rose-100 hover:bg-rose-100 transition-all"
                      >
                        ยกเลิกการส่ง
                      </button>
                    </div>
                  </div>
                )}

                {transaction?.status === "confirm" && (
                  <div className="flex flex-col gap-3">
                    <div className="grid grid-cols-3 gap-3">
                      <div className="col-span-1 h-20 bg-gray-100 text-gray-400 rounded-2xl font-black flex items-center justify-center text-sm uppercase tracking-widest border border-gray-200">
                        ยืนยันแล้ว
                      </div>
                      <button
                        onClick={() => setOpenPrintDialog(true)}
                        disabled={!hasPermission(["Print"])}
                        className="col-span-1 h-20 bg-slate-800 text-white rounded-2xl font-black text-lg shadow-lg hover:bg-slate-900 active:scale-95 transition-all"
                      >
                        พิมพ์ A4
                      </button>
                      <button
                        onClick={() => handleUpdate("payed")}
                        className="col-span-1 h-20 bg-emerald-600 text-white rounded-2xl font-black text-lg shadow-lg shadow-emerald-100 hover:bg-emerald-700 active:scale-95 transition-all flex flex-col items-center justify-center"
                      >
                        ได้รับเงินแล้ว
                      </button>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <button
                        onClick={() => (window.location.href = "/sale")}
                        className="col-span-1 h-14 bg-white text-slate-800 rounded-2xl font-black text-sm border border-gray-200 hover:bg-gray-50 transition-all"
                      >
                        ปิดหน้าตั๋ว
                      </button>
                      <button
                        onClick={() => handleUpdate("waiting")}
                        className="col-span-1 h-14 bg-rose-50 text-rose-500 rounded-2xl font-black text-sm border border-rose-100 hover:bg-rose-100 transition-all"
                      >
                        ยกเลิกการยืนยัน
                      </button>
                    </div>
                  </div>
                )}

                {transaction?.status === "payed" && (
                  <div className="flex flex-col gap-3">
                    <div className="grid grid-cols-3 gap-3">
                      <div className="col-span-1 h-20 bg-gray-100 text-emerald-500 rounded-2xl font-black flex items-center justify-center text-sm uppercase tracking-widest border border-gray-200 gap-1">
                        <CheckCircleIcon fontSize="small" /> จ่ายแล้ว
                      </div>
                      <button
                        onClick={() => setOpenPrintDialog(true)}
                        disabled={!hasPermission(["Print"])}
                        className="col-span-1 h-20 bg-slate-800 text-white rounded-2xl font-black text-lg shadow-lg hover:bg-slate-900 active:scale-95 transition-all"
                      >
                        พิมพ์ A4
                      </button>
                      <button
                        disabled
                        className="col-span-1 h-20 bg-gray-100 text-gray-400 rounded-2xl font-black flex items-center justify-center text-sm uppercase tracking-widest border border-gray-200"
                      >
                        ได้รับเงินแล้ว
                      </button>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <button
                        onClick={() => (window.location.href = "/sale")}
                        className="col-span-1 h-14 bg-white text-slate-800 rounded-2xl font-black text-sm border border-gray-200 hover:bg-gray-50 transition-all"
                      >
                        ปิดหน้าตั๋ว
                      </button>
                      <button
                        onClick={() => handleUpdate("confirm")}
                        className="col-span-1 h-14 bg-rose-50 text-rose-500 rounded-2xl font-black text-sm border border-rose-100 hover:bg-rose-100 transition-all"
                      >
                        ยกเลิกการรับเงิน
                      </button>
                    </div>
                  </div>
                )}

                {transaction?.status === "cancel" && (
                  <div className="flex gap-3">
                    <button
                      onClick={() => handleUpdate("uncancel")}
                      className="flex-1 bg-rose-50 text-rose-500 p-4 rounded-2xl border border-rose-100 font-black text-center uppercase tracking-widest hover:bg-rose-100 transition-all disabled:opacity-30 shadow-sm"
                    >
                      ยกเลิกการยกเลิกบิล
                    </button>
                    <button
                      onClick={() => (window.location.href = "/sale")}
                      className="w-1/3 h-full bg-white text-slate-800 rounded-2xl font-black border border-gray-200 hover:bg-gray-50"
                    >
                      ปิดหน้าตั๋ว
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div >

      <ImageModal
        open={openImg}
        onClose={() => setOpenImg(false)}
        imageDetail={imageDetail}
        selectedImage={selectedImage}
        type={type}
      />

      <SaleDestinationConfirmDialog
        open={openDestinationDialog}
        transaction={transaction}
        onClose={() => setOpenDestinationDialog(false)}
        onConfirm={handleDestinationConfirm}
      />

      <SalesProductFormDialog
        key={`${transactionId}-${selectedValue?.itemId ?? selectedValue?.id ?? "new"}`}
        selectedValue={selectedValue}
        transaction={transaction}
        stockByProductId={stockByProductId}
        waitingSaleNetByProductId={waitingSaleNetByProductId}
        customer={transaction?.customer}
        open={openProductDialog}
        onClose={handleClose}
        onSubmit={handleSubmit}
      />

      <WeightDialog
        transaction={transaction}
        open={openCarDialog}
        onClose={() => setOpenCarDialog(false)}
        onConfirm={handleConfirm}
        weighingFlow="sale"
      />

      <PDFDialog
        open={openPDF}
        onClose={() => setOpenPDF(false)}
        onSelect={handleSelectPDF}
      />

      <SaleCustomerPickerDialog
        open={openCustomerPickerDialog}
        onClose={() => setOpenCustomerPickerDialog(false)}
        showCreateButton
        onSuccess={handleChangeCustomer}
      />

      <SOSelectionDialog
        open={openSOSelectionDialog}
        onClose={() => setOpenSOSelectionDialog(false)}
        transaction={transaction}
        soItems={soItems}
        soSelect={soSelect}
        setSoSelect={setSoSelect}
        insuranceEnabled={insuranceEnabled}
        lockItems={lockItems}
        lockSelect={lockSelect}
        setLockSelect={setLockSelect}
        locksLoading={locksLoading}
        locksError={locksError}
        readOnly={!canEditSaleItems}
      />

      <Delivery
        open={openShippingDialog}
        onClose={() => setOpenShippingDialog(false)}
        transaction={transaction}
        onSubmit={handleShippingSubmit}
      />

      <StockTypeDialog
        open={openStockTypeDialog}
        onClose={() => setOpenStockTypeDialog(false)}
        selected={type}
        badgeNumber={7} // เอาออกได้ถ้าไม่ต้องการ
        onSelect={(val) => {
          if (val === "retail") {
            setOpenProductDialog(true);
            setOpenStockTypeDialog(false);
          } else {
            setOpenPackageSelectDialog(true);
          }
        }}
      />

      <PackageSelectDialog
        open={openPackageSelectDialog}
        onClose={() => setOpenPackageSelectDialog(false)}
        productId={selectedValue?.id}
        onConfirm={(row) => {
          console.log("เลือกแพ็ค:", row);
          setSelectedPackage(row);
          setOpenStockTypeDialog(false);
          setOpenPackageSelectDialog(false);
          setOpenProductDialog(true);
        }}
      />

      <ItemTableModal
        open={openItemDialog}
        onClose={() => {
          setOpenItemDialog(false);
          setSelectedItem(null);
        }}
        item={selectedItem}
        onOpenExtraPrice={handleOpenSaleExtraPrice}
        isSale
      />
      <SaleInsuranceExtraPriceModal
        open={openSaleExtraPriceDialog}
        onClose={() => {
          setOpenSaleExtraPriceDialog(false);
          setSelectedSaleExtraItem(null);
        }}
        item={selectedSaleExtraItem}
        onSave={handleSaveSaleExtraPrice}
      />
      <PaymentMethodDialog
        open={openPrintDialog}
        onClose={() => setOpenPrintDialog(false)}
        onSelect={async (method) => {
          await handleSelectPDF(method);
        }}
      />
    </>
  );
};

export default Page;
